<template>
	<div :class="theme">
		<div class="profile">
			<Title :zhTitle="pageData.name" :enTitle="pageData.name"></Title>
			<div class="content">
				<div v-if="language === 'zh'" class="describe" v-text="jsonData.aboutUs"></div>
				<div v-else-if="language === 'en'" class="describe" style="font-size: 14px; overflow-y: auto" v-text="jsonData.aboutUsEng"></div>
			</div>
		</div>
	</div>
</template>

<script>
import Title from '@/components/title.vue'
import { mapState } from 'vuex'

export default {
	name: 'profile',
	components: {
		Title,
	},
	props: {
		index: {
			type: Number,
		},
	},
	data() {
		return {
			pageData: {},
		}
	},
	computed: {
		...mapState(['theme', 'language', 'jsonData']),
	},
  watch:{
    language(newVal, oldVal) {
      let data = JSON.parse(this.jsonData.moduleData)
      if (newVal == 'zh') { // 根据语言获取相应数据
        data = JSON.parse(this.jsonData.moduleData)
      } else {
        data = JSON.parse(this.jsonData.moduleDataEng)
      }
      this.pageData = data[this.index]
    }
  },
  mounted() {
    let data = JSON.parse(this.jsonData.moduleData)
    if (this.language == 'zh') { // 根据语言获取相应数据
      data = JSON.parse(this.jsonData.moduleData)
    } else {
      data = JSON.parse(this.jsonData.moduleDataEng)
    }
    this.pageData = data[this.index]
  },
	methods: {},
}
</script>

<style lang="scss" scoped>
.red {
	.profile {
		margin-top: 14px;
		width: 1040px;
		height: 503px;
		position: relative;
		background: #ffffff;
		box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
	}
}

.purple {
	.profile {
		margin-top: 14px;
		width: 1040px;
		height: 503px;
		position: relative;
		background: #ffffff;
		box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
	}
}
.content {
	height: 370px;
	margin-top: 12px;
	padding: 0 46px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.describe {
	width: 880px;
	padding: 15px;
	min-height: 155px;
	max-height: 330px;
	overflow-y: auto;
	border-radius: 8px;
	border: 1px solid var(--borderColor);
	font-size: 16px;
	font-weight: 400;
	color: var(--timeTitleColor);
	line-height: 28px;
  white-space: pre-wrap;
}

.blue {
	.profile {
		padding: 0 80px;
		padding-top: 27px;
		width: 980px;
		height: 489px;
		position: relative;
	}

	.content {
		margin-top: 34px;
		padding: 0;
		width: 980px;
		height: 375px;
		background: #ecf2fd;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.describe {
		overflow-y: auto;
		border-radius: 8px;
		font-size: 17px;
		font-weight: 400;
		color: var(--timeTitleColor);
		line-height: 32px;
		overflow: hidden;
		border: none;
	}
}

.yellow {
	.profile {
		width: 980px;
		height: 510px;
		padding: 0 80px;
		background: #f5f6f8;
		border-radius: 28px;
		position: relative;
	}

	.content {
		margin-top: 34px;
		padding: 0;
		width: 980px;
		height: 375px;
		background: #ffffff;
		box-shadow: 6px 2px 9px 0px rgba(165, 165, 165, 0.2);
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.describe {
		overflow-y: auto;
		border-radius: 8px;
		font-size: 17px;
		font-weight: 400;
		color: var(--timeTitleColor);
		line-height: 32px;
		overflow: hidden;
		border: none;
	}
}

.purple {
	.describe {
		border: none;
	}
}

.scroll-area {
	position: relative;
	height: 100%;
}

.ps__rail-x,
.ps__rail-y {
	/* 自定义滚动条轨道样式 */
	background-color: #f1f1f1;
	opacity: 0.6;
}

.ps__thumb-x,
.ps__thumb-y {
	/* 自定义滚动条滑块样式 */
	background-color: #888;
}

.ps__thumb-x:hover,
.ps__thumb-y:hover {
	/* 自定义滚动条滑块悬停样式 */
	background-color: #555;
}
</style>
